import React from 'react';
import { cn } from '@/utils/cva';
import { videoElementStyles } from './VideoElement.styles';

interface IVideoElementProps {
  videoRef: React.RefObject<HTMLVideoElement>;
  src: string;
  poster?: string;
  classNames?: {
    video?: string;
  };
  onPlay?: () => void;
  onPause?: () => void;
  setIsPlaying: (__isPlaying: boolean) => void;
}

export const VideoElement = ({
  videoRef,
  src,
  poster,
  classNames,
  onPlay,
  onPause,
  setIsPlaying,
}: IVideoElementProps) => {
  return (
    <video
      ref={videoRef}
      className={cn(videoElementStyles(), classNames?.video)}
      poster={poster}
      src={src}
      controls
      playsInline
      onEnded={() => {
        setIsPlaying(false);
        onPause?.();
      }}
      onPause={() => {
        setIsPlaying(false);
        onPause?.();
      }}
      onPlay={() => {
        setIsPlaying(true);
        onPlay?.();
      }}
    />
  );
};
